import styled from "styled-components";

const TooltipContainer = styled.span`
  position: relative;
`;

const TooltipBubble = styled.div`
  min-width: 120px;
  max-width: 210px;
  width: ${props => (props.width ? `${props.width}px` : "100%")};
  position: absolute;
  z-index: 1003;
  border-radius: 4px;
  background-color: #222939;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33;
  color: #ffffff;
  padding: 8px;
  animation: fadein 0.2s ease-in;

  @media (max-width: 768px) {
    width: 100%;
  }

  @keyframes fadein {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  /* Position TOP */
  bottom: ${props => `${props.offsetHeight + 6}px`};
  right: ${props => (props.position === "top-right" ? "0px" : "unset")};
  left: ${props => (props.position === "top-left" ? "0px" : "unset")};
`;

const TooltipMessage = styled.div`
  position: relative;
`;

const TooltipTrigger = styled.div`
  display: inline-block;
`;

export { TooltipContainer, TooltipBubble, TooltipMessage, TooltipTrigger };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/components/tooltip/TooltipStyle.js